export const GET_REPRESENTATIVES_ERP = 'generics/GET_REPRESENTATIVES_ERP';
export const SET_REPRESENTATIVES_ERP = 'generics/SET_REPRESENTATIVES_ERP';
export const SET_ADDRESS = 'generics/SET_ADDRESS';
export const GET_ADDRESS = 'generics/GET_ADDRESS';
export const SET_CLIENT = 'generics/SET_CLIENT';
export const GET_CLIENT = 'generics/GET_CLIENT';
export const SET_CONTACT_FORM = 'generics/SET_CONTACT_FORM';
export const GET_CONTACT_FORM = 'generics/GET_CONTACT_FORM';
export const SET_CLIENT_LIST = 'generics/SET_CLIENT_LIST';
export const GET_CLIENT_LIST = 'generics/GET_CLIENT_LIST';
export const SET_CARRIER = 'generics/SET_CARRIER';
export const GET_CARRIER = 'generics/GET_CARRIER';
export const SET_OPTIONALS_GRID = 'generics/SET_OPTIONALS_GRID';
export const GET_OPTIONALS_GRID = 'generics/GET_OPTIONALS_GRID';
export const OPEN_SIDEBAR = 'generics/OPEN_SIDEBAR';
export const GET_STATE = 'generics/GET_STATE';
export const SET_STATE = 'generics/SET_STATE';
export const GET_CITY = 'generics/GET_CITY';
export const SET_CITY = 'generics/SET_CITY';




export default {
	GET_REPRESENTATIVES_ERP,
	SET_REPRESENTATIVES_ERP,
	SET_ADDRESS,
	GET_ADDRESS,
	SET_CLIENT,
	GET_CLIENT,
	SET_CONTACT_FORM,
	GET_CONTACT_FORM,
	SET_CLIENT_LIST,
	GET_CLIENT_LIST,
	SET_CARRIER,
	GET_CARRIER,
	SET_OPTIONALS_GRID,
	GET_OPTIONALS_GRID,
	OPEN_SIDEBAR,
	GET_STATE,
	SET_STATE,
	GET_CITY,
	SET_CITY
};
